import { Divider } from "antd";
import { ReactComponent as KakaoChannel } from "../../../../assets/images/icon/kakao-channel-logo.svg";
import { deepLinkBridgeElseNewTab } from "../../../../utils"

const KakaoInquiry = () => {

    return <>
        <div style={{ marginTop: 60, position: 'relative', height: 156 }}>
            <div style={{ position: 'absolute', width: '100%', maxWidth: '480px' }}>
                <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                <div className="body/b2 secondary/s800" style={{ padding: '24px 20px', textAlign: 'center' }}>
                    <div>궁금한 점이 있으신가요?</div>
                    <div>카카오 채널을 통해 문의주시면 빠르게 답변드리겠습니다.</div>
                    <div style={{ paddingTop: 18 }}>
                        <KakaoChannel width={40} height={40} style={{ cursor: 'pointer' }} onClick={() => deepLinkBridgeElseNewTab('https://pf.kakao.com/_xmWxbYG/chat')} />
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default KakaoInquiry